import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Search from './Search'

import { addTopic, searchTopics } from '../../../actions/topics'
import { flashNewItem } from '../../../utils/animation'
import { direct, supplemental } from '../../../utils/messages'

export default class TopicAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newTopicType: ''
    }

    this.onSelectNewTopicBound = this.onSelectNewTopic.bind(this)
    this.addTopicBound = this.addTopic.bind(this)
  }

  render() {
    return (
      <div className="topic-add">
        <div className="header-label">
          Select the subtopics and standards that align with the content or
          skills in this quest. Make sure that the quest provides ample
          opportunity for students to develop content knowledge or skills in the
          subtopic or standard you select. You may link this quest to multiple
          subtopics from any number of topic clouds or standard sets.
        </div>
        <div id="addLinkedTopic">
          <h3>Link this quest to a topic or standard:</h3>
          <div id="topicContextSelect">
            <div className="context-toggle">
              <div>
                <input
                  type="radio"
                  id="direct"
                  name="topiccontext"
                  className="form-control context direct"
                  onClick={this.onSelectNewTopicBound}
                />
                <label htmlFor="direct">{direct}</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="supplemental"
                  name="topiccontext"
                  className="form-control context supplemental"
                  onClick={this.onSelectNewTopicBound}
                />
                <label htmlFor="supplemental">{supplemental}</label>
              </div>
            </div>
          </div>
          {this.state.newTopicType && (
            <Search
              searchResults={this.props.topicSearchResults}
              addItem={this.addTopicBound}
              dispatch={this.props.dispatch}
              isSearching={this.props.isSearching}
              searchItems={searchTopics}
            />
          )}
        </div>
      </div>
    )
  }

  onSelectNewTopic(e) {
    this.setState({
      newTopicType: e.target.id
    })
  }

  async addTopic(topicId) {
    await this.props.dispatch(
      addTopic(this.props.questId, topicId, this.state.newTopicType)
    )

    // "flash" animation for newly added topic
    flashNewItem({
      itemId: topicId,
      classToAdd: 'quest-topic editing',
      autoscroll: true
    })
    // Reset the context radio input and component state
    document.getElementById(this.state.newTopicType).checked = false
    this.setState(() => {
      return {
        newTopicType: ''
      }
    })
  }
}

TopicAdd.propTypes = {
  questId: PropTypes.number,
  dispatch: PropTypes.func,
  topicSearchResults: PropTypes.array,
  isSearching: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/quest/topics/TopicAdd.js